module.exports = __webpack_public_path__ + "static/media/devolu_black.c01d607a.png";